

export default {
  ns1:'1. Nameserver',
  ns2:'2. Nameserver',
  ns3:'3. Nameserver',
  ns4:'4. Nameserver',
  ns5:'5. Nameserver',
  ownerC: 'Inhaber',
  adminC: 'Administrativer Kontakt',
  techC: 'Technischer Kontakt',
  zoneC: 'Zonenverwalter',
  dates:{
    created_at:'Erstellt',
    'delete' : 'Kündigung',
    expire: 'Vertragsende',
    suspended_at:'Gekündigt am',
    suspended_until:'Kündigung zum',
    updated_at:'Aktualisiert'
  },
  searchInput:{
    submitButton:'Suchen',
    placeholder:'Wunsch-Domain suchen'
  },
  nameserver:{
    ns1:'1. Nameserver',
    ns2:'2. Nameserver'
  },
  optionalNameserver:{
    ns3:'3. Nameserver',
    ns4:'4. Nameserver',
    ns5:'5. Nameserver'
  },
  contacts: {
    ownerC: 'Inhaber',
    adminC: 'Administrativer Kontakt',
    techC: 'Technischer Kontakt',
    zoneC: 'Zonenverwalter',
  },

  // TOOK OUT OF OBJECT
  types: {
    PERS: 'Person',
    ORG: 'Organisation',
    ROLE: 'Rolle'
  },
  authinfo:'Authentifizierungscode',
  unavailable: 'Registriert',
  enter_authinfo: 'Domain nicht Verfügbar oder AuthInfo eingeben'
}



// WEBPACK FOOTER //
// ./src/lang/de/domain.js